<template>
    <div id="fixedHeader" class="fixed-header rd-game-header">
        <statusBar></statusBar>
        <div class="pages-header">
            <div @click="onNavBack">
                <img class="fanhui" src="@/assets/signIn/back.png" alt="" draggable="false">
                <!-- <img class="logo" :src="logoUrl" @click.stop="toHome" /> -->
                <img v-if="device == 'mobile'" class="logo" style="height: .75rem;" :src="logoUrl2" @click.stop="toHome" />
                <img v-else class="logo" :src="logoUrl" @click.stop="toHome" />
            </div>
            <div class="user_action">
                <div></div>
                <div class="user_info">
                    <!-- <div class="CurrencyType"><span>{{ CurrencyType }}</span></div> -->
                    <!-- <div>
                        <div class="user_money">
                            <span style="margin-left: 4px;">{{ userInfo && userInfo.balanceAmtAccount ?
                                formatAmount(userInfo.balanceAmtAccount.useBalance, 1) : "0.0" }}</span>
                        </div>
                        <div class="user_account">
                            <span style="margin-left: 4px;">{{ userInfo && userInfo.bonusAmtAccount ?
                                formatAmount(userInfo.bonusAmtAccount.useBalance, 1) : "0.0" }}</span>
                        </div>
                    </div> -->
                    <div class="deposit deposit_app" @click.stop="toDeposit">+</div>
                    <div class="deposit deposit_PC" @click.stop="toDeposit">{{ $t("deposit.Deposit") }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import statusBar from '@/components/statusBar'
import { mapState } from 'vuex'
export default {
    name: 'gameHeader',
    components: { statusBar },
    data() {
        return {}
    },
    computed: {
        ...mapState({
            device: state => state.app.device
        }),
        logoUrl() {
            return this.$store.getters.sysConfig?.homeLogoUrl
        },
        logoUrl2() {
            return this.$store.getters.sysConfig?.homeImageUrl
        },
        userInfo() {
            return this.$store.getters.userInfo
        }
    },
    created() { },
    methods: {
        onNavBack() {
            this.$emit('onNavBack')
        },
        toHome() {
            this.$emit('toHome')
        },
        toDeposit() {
            const params = { type: 'deposit' }
            this.onNavTo({ url: '/wallet', type: 'get', params })
        }
    }
}
</script>

<style scoped lang="scss">
    @import '@/common/styles/viriables.scss';
.fixed-header {
    width: 100%;
    position: relative;
    z-index: 98;
    box-shadow: 0 4px 20px rgba($bg-shell-color, .24);
    background: rgb(0, 0, 0, 0.4);

    .pages-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0;
        height: 1rem;
        padding-right: 1rem;
        box-sizing: border-box;
        position: relative;

        &>div:first-child {
            display: flex;
            align-items: center;
            padding-left: .2rem;
            position: absolute;
            height: 100%;
            left: 0;
            top: 0;
            z-index: 3;

            .fanhui {
                width: 0.48rem;
                height: 0.48rem;
                margin-right: .24rem;
            }

            .logo {
                height: .48rem;
                width: auto;
                will-change: auto !important;
                cursor: pointer;
            }
        }

        .user_action {
            display: flex;
            align-items: center;
            justify-content: space-between;
            position: relative;
            z-index: 2;
            width: 100%;

            .user_info {
                display: flex;
                align-items: center;
                // column-gap: 10px;
                font-size: .24rem;
                background: transparent;
                // border: 1px solid $border-home-popup-color;
                // padding: .01rem .15rem;
                // padding-right: .08rem;
                border-radius: .1rem;

                .CurrencyType {
                    background: $bg-component-danger-color;
                    padding: .02rem;
                    border-radius: 50%;
                    flex-shrink: 0;
                    width: .36rem;
                    height: .36rem;
                    text-align: center;
                    line-height: .36rem;
                    color: $font-color;
                    font-size: .23rem;
                }

                .user_account,
                .user_money {
                    // display: flex;
                    // align-items: center;
                    color: $font-color;
                    // background: rgba(255, 255, 255, 0.15);
                    padding: 0 .08rem;
                    border-radius: .2rem;
                }

                .user_account {
                    color: $font-component-rose-muted-color;
                }

                .icon-shuaxin {
                    font-size: .2rem;
                    color: $font-component-hot-strong-color;
                }

                .deposit {
                    height: .65rem;
                    border-radius: .65rem;
                    background: var(--theme-gold-bg);
                    color: var(--theme-gold-text);
                    box-shadow: inset 0 1px 0 rgba($font-title-color, .24), 0 .08rem .16rem rgba($bg-shell-color, .18);
                    line-height: .65rem;
                    // margin-left: .1rem;

                    &.deposit_app {
                        display: none;
                        width: .6rem;
                    }

                    &.deposit_PC {
                        font-size: .3rem;
                        font-weight: bold;
                        padding: 0 .4rem;
                        text-transform: uppercase;
                        cursor: pointer;
                    }
                }
            }
        }
    }
}

html[data-device-nodesktop="1"] {
    .fixed-header {
        z-index: 100;

        .downApp {
            display: none;
        }
    }
}

.fixed-header {
    .pages-header {
        & > div:first-child > i {
            color: $font-component-info-strong-color;
        }
    }
}
</style>
